import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { UntypedFormArray } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { Owner } from '@app/forms/subscription/definition/interface/Pledge';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { UntilDestroy } from '@ngneat/until-destroy';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@UntilDestroy()
@Component({
    selector: 'risques-client-personne-morale',
    templateUrl: './risques-client-personne-morale.component.html',
    styleUrls: ['./risques-client-personne-morale.component.scss'],
    standalone: false
})
export class RisquesClientPersonneMoraleComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  @ViewChild('linearVerticalStepper', { static: true })
  private steper: MatStepper;
  currentPageNumber: number = 0;
  itemsPerPage: number = 1;
  owners: Owner[] = [];

  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
    protected injector: Injector,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    const pledge = this.subscriptionFacade.getPledge();
    this.owners = pledge?.owners;
    this.initForm(pledge?.owners, pledge.accountId);
  }

  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.selectErrorInputAndScroll(this);
    this.extract();

    if (
      this.pledgeOwners.controls[this.currentPageNumber]?.valid &&
      this.currentPageNumber == this.owners.length - 1
    )
      this.subscriptionFacade.submitPledge(this, 'owners');
    if (
      this.pledgeOwners.controls[this.currentPageNumber]?.valid &&
      this.currentPageNumber < this.owners.length - 1
    ) {
      this.subscriptionFacade.submitPledge(
        this,
        'owners',
        false,
        this.nextStep.bind(this),
        true,
      );
    }
  }
  prev() {
    if (this.currentPageNumber == 0) {
      this.subscriptionFacade.previousStep();
    }
    if (this.currentPageNumber > 0) this.currentPageNumber--;
    this.steper.previous();
  }
  nextPage() {
    this.currentPageNumber++;
  }

  nextStep() {
    this.currentPageNumber++;
    this.steper.next();
    this.steper.selected.completed = true;
  }
  prevStep() {
    if (this.currentPageNumber == 0) {
      this.subscriptionFacade.previousStep();
      this.steper.previous();
    }
    if (this.currentPageNumber > 0) this.currentPageNumber--;
  }
  stepClick(ev) {
    this.currentPageNumber = ev.selectedIndex;
  }

  get pledgeOwners() {
    return this.form.get('pledgeOwners') as UntypedFormArray;
  }
}
